module.exports = __webpack_public_path__ + "static/media/us.026a8970.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/us.svg
// module id = 2237
// module chunks = 0